import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import TaskImageEdit from '../task-image-edit';

interface ImageEditModalProps {
  open: boolean;
  onClose: () => void;
  editingImageFile: File | null;
  onSave: (editedBlob: Blob) => Promise<void>;
}

export default function ImageEditModal({
  open,
  onClose,
  editingImageFile,
  onSave,
}: ImageEditModalProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  console.log('ImageEditModal render:', { open, editingImageFile: !!editingImageFile, isMobile });
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      fullScreen={isMobile} // Fullscreen nur auf Mobile
      PaperProps={{
        className: 'modal-dialog',
        sx: {
          height: { xs: '100vh', sm: '90vh' }, // Mobile: Vollbild, Desktop: 90%
          maxHeight: { xs: '100vh', sm: '90vh' },
          width: { xs: '100vw', sm: '90vw', md: '80vw', lg: '70vw' },
          maxWidth: { xs: '100vw', sm: '90vw', md: '80vw', lg: '70vw' },
          margin: { xs: 0, sm: 'auto' },
        },
      }}>
      <DialogTitle sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        Bild bearbeiten
        <Button onClick={onClose}>
          ✕
        </Button>
      </DialogTitle>
      <DialogContent sx={{p: 0, height: 'calc(100% - 64px)', overflow: 'hidden', display: 'flex', flexDirection: 'column'}}>
        {editingImageFile && (
          <TaskImageEdit
            imageFile={editingImageFile}
            onSave={onSave}
            onCancel={onClose}
            maxWidth={isMobile ? Math.min(window.innerWidth - 20, 600) : 1000}
            maxHeight={isMobile ? Math.min(window.innerHeight - 200, 400) : 600}
            inModal={true}
          />
        )}
        {!editingImageFile && (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            Bild wird geladen...
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
